import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router, UrlTree } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AnonymousGuardCustomerService {
  message = new BehaviorSubject('message');

  currentMessage = this.message.asObservable();
  constructor(private auth: AuthService, private router: Router, public jwtHelper: JwtHelperService) {}

  changeMessage(message: string) {
    this.message.next(message);
  }
  public getToken(): string {
    return localStorage.getItem('accessToken');
  }
  public isAthenticated(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    // A token only counts as "authenticated" if it is a valid, non-expired
    // customer token. A leftover/malformed token (e.g. after a partial logout)
    // must NOT be treated as logged-in, otherwise the login page never renders.
    try {
      if (this.jwtHelper.isTokenExpired(token)) {
        return false;
      }
      const decoded = this.jwtHelper.decodeToken(token);
      return !!(decoded && decoded.roles && decoded.roles.indexOf('customer') !== -1);
    } catch (e) {
      return false;
    }
  }
  canActivate(): boolean | UrlTree {
    // Not logged in -> allow the login page to render.
    if (!this.isAthenticated()) {
      return true;
    }
    // Already logged in -> redirect to the app.
    // Return a UrlTree so Angular performs ONE atomic redirect. The previous
    // implementation returned `undefined` (no explicit return) and fired a
    // nested router.navigate() inside a synchronous subscribe; the undefined
    // cancelled the /login navigation while the nested navigate raced it,
    // intermittently leaving a blank page.
    return this.router.createUrlTree(['/home/requests']);
  }
}